import { TNavigation } from "data/navigation";
import { atom } from "recoil";
import { THallList } from "pages/WeddingHall/WeddingHall";
import {
  ICounselingDateInfo,
  IFittableWedding,
  IWeddingDateInfo,
} from "store/data/data";
import { IUser, TLoginType } from "data/user";

export const footerState = atom<boolean>({
  key: "footerStateKey",
  default: false,
});

export const navigationState = atom<TNavigation>({
  key: "navigationStateKey",
  default: "home",
});

export const userState = atom<IUser | undefined>({
  key: "userState",
  default: undefined,
});

export const signOnState = atom<
  | {
      id: string;
      token: string;
      type: TLoginType;
    }
  | undefined
>({
  key: "signOnState",
  default: undefined,
});

export const userSelectHall = atom<THallList[]>({
  key: "userSelectHall",
  default: [],
});

export const userSelectDate = atom<IWeddingDateInfo>({
  key: "userSelectDate",
  default: {
    wantToMonth: [],
    wantToTime: [],
    wantTotHeadCount: [],
    wantToHeadCountOption: [],
    wantToDay: [],
    HeadCountOptionText: "",
    wantWeddingHallName: "",
    wantWeddingHallType: "",
  },
});

export const userSelectCounseling = atom<ICounselingDateInfo[]>({
  key: "userSelectCounseling",
  default: [],
});

export const userSelectFittableHall = atom<IFittableWedding>({
  key: "userSelectFittableHall",
  default: {
    wantCity: [],
    wantLocation: [],
    wantWeddingHallType: [],
    wantConcurrent: [],
    wantMenu: [],
    wantPeriod: [],
    expectCount: [],
  },
});

export const headerAndBottomVisibleState = atom<{
  isHeader: boolean;
  isBottom: boolean;
  OS: string;
  reserve: boolean;
}>({
  key: "headerAndBottomVisible",
  default: {
    isHeader: true,
    isBottom: true,
    OS: "",
    reserve: false,
  },
});

export const OSState = atom({
  key: "OSState",
  default: "ios" || "android",
});
